import {
  EventActionsEnum,
  EventActionTypesEnum,
  EventModuleTypesEnum,
  rudderstackReset,
  trackAnalyticsEvent,
} from "@agridigital/waypath-analytics-ts-shared.fe-analytics-utils";
import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React, { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";

import Logo from "../../assets/AgriDigital_Lockup_Horizontal_Colour.svg";
import { Layout } from "../../components/common";
import IssueBanner from "../../components/common/IssueBanner";
import { Report } from "../../components/reports";

const insights_api_url = process.env.REACT_APP_INSIGHTS_API;
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="h-full"
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

// const useStyles = makeStyles((theme: Theme) => ({
//   tabs: {
//     backgroundColor: "#F5F5EF",

//     display: "flex",
//     flexWrap: "wrap",
//   },
//   tab: {
//     "&:focus": {
//       outline: "none",
//     },
//     '&.Mui-selected': {
//       color: '#060808', // replace with your primary color here
//     },
//     color: "#060808",
//   },
// }));

const Dashboard = ({ history }: any) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const axios = require("axios").default;
  const isAuth = localStorage.getItem("accessToken");
  // const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<any>, newValue: number) => {
    trackAnalyticsEvent("dashboard_changereport", {
      module: "dashboard",
      view: "login",
      action: EventActionsEnum.VIEW,
      actionType: EventActionTypesEnum.CLICK,
      reportName: data[newValue]?.name,
      reportId: data[newValue]?.id,
    });

    setValue(newValue);
  };
  const handleLogout = () => {
    trackAnalyticsEvent("home_logout", {
      module: EventModuleTypesEnum.AUTH,
      view: "logout",
      action: EventActionsEnum.SUBMIT,
      actionType: EventActionTypesEnum.CLICK,
      formsubmitresult: "Success",
    });
    rudderstackReset();
    localStorage.removeItem("accessToken");
    history.push("/");
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(insights_api_url, {
        headers: {
          accept: "text/plain",
          Authorization: `Bearer ${isAuth}`,
        },
      })
      .then((response: Record<string, number>) => {
        if (response) {
          setData(response.data);
        }
        setLoading(false);
      })
      .catch((error: Record<string, number>) => {
        setLoading(false);
        console.error("ERROR:", error.response);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout history={history}>
      {loading ? (
        <div className="h-full w-full flex flex-row justify-center items-center text-3xl font-foundersGrotesk">
          <div className="flex flex-row items-center justify-center">
            <p className="text-2xl">Fetching Report</p>
            <FaSpinner className="font-foundersGrotesk ml-2 animate-spin text-agBarley500" />
          </div>
        </div>
      ) : (
        <>
          <div className="flex-grow">
            <div className="grid grid-cols-2 gap-4 mx-8 my-4 md:grid-cols-6 md:gap-8  xl:grid-cols-12 xl:gap-10">
              {/* Primary Container */}
              <div className="col-span-2 col-start-1 md:col-span-4 xl:col-span-4 ">
                <div className="flex flex-row">
                  <div>
                    <img
                      src={Logo}
                      alt="logo"
                      className=""
                      style={{ height: 40 }}
                    />
                  </div>
                  <div className="ml-4 text-4xl text-center mb-4 font-foundersGrotesk text-agBarley500 font-semibold">
                    Insights
                  </div>
                </div>
              </div>
            </div>
            <div>
              <IssueBanner />
            </div>
            <AppBar position="static" className="">
              <Tabs
                // className={classes.tabs}
                value={value}
                onChange={handleChange}
                aria-label="report tabs"
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { background: "#97aD69" } }}
              >
                {data.map((item: any, index: number) => (
                  <Tab
                    // className={classes.tab}
                    label={item.name}
                    key={index}
                    {...a11yProps(index)}
                  />
                ))}
              </Tabs>
            </AppBar>
            {data.map((item: any, index: number) => (
              <TabPanel value={value} index={index} key={index}>
                <Report number={data[value]?.id} />
              </TabPanel>
            ))}
            <div className="fixed text-right w-full bottom-0 p-4">
              <button
                onClick={handleLogout}
                className="uppercase font-semibold mt-8 px-12 py-5 leading-none leading-none text-lg rounded-full bg-agBarley500 text-agWhite font-foundersGrotesk hover:bg-agBarley600 focus:outline-none"
              >
                Logout
              </button>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};

export default Dashboard;
